module.exports = __webpack_public_path__ + "static/media/seo.7cfc5f4c.jpg";